import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { FaPhone, FaGlobe } from "react-icons/fa";
import { useAssets } from "../../Context/AssetsContext";

const VoterIDCard = React.forwardRef(({ selectedCard }, ref) => {
  const { assets } = useAssets();
  return (
    <div
      className="flex justify-center items-center w-full mt-5 overflow-x-auto"
      ref={ref}
    >
      <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-5">
        {/* === FRONT SIDE === */}
        <div
          className="w-[340px] h-[210px] bg-cover bg-center border border-black rounded p-1 relative"
          style={{ backgroundImage: `url(${assets.voter})` }}
        >
          {/* Header */}
          <div className="absolute top-2 left-2 w-[94%] flex justify-between items-center">
            <img src={assets.ashok1} alt="Ashok Stambh" className="w-5 h-8" />

            <div className="leading-[0.8rem] ">
              <p className="text-[0.55rem] font-semibold">ଭାରତ ନିର୍ବାଚନ ଆୟୋଗ</p>
              <p className="text-[0.55rem] font-semibold">
                ELECTION COMMISSION OF INDIA
              </p>
              <p className="text-[0.55rem] font-semibold">
                ଭୋଟର ଫୋଟୋ ପରିଚୟ ପତ୍ର - Elector Photo Identity Card
              </p>
            </div>

            <img src={assets.voteLogo} alt="Vote Logo" className="w-6 h-6" />
          </div>

          {/* EPIC Number */}
          <p className="absolute top-[64px] left-3.5 text-[0.45rem] font-bold text-center tracking-widest">
            {selectedCard.epic_no}
          </p>

          {/* Voter Photo */}
          <div className="absolute top-[80px] left-2 w-[75px] h-[90px] border-[1px] border-black">
            <img
              src={selectedCard.photoUrl}
              alt="Voter"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Voter Details */}
          <div className="absolute top-[80px] left-[92px] text-[0.55rem] leading-snug tracking-tight space-y-[2px]">
            <p>
              <span className="font-semibold">ନାମ :</span>
              <span className="font-semibold"> {selectedCard.name_v2}</span>
            </p>
            <p>
              <span className="font-semibold">Name:</span>
              <span className="font-semibold"> {selectedCard.name}</span>
            </p>

            <p>
              <span className="font-semibold">ପିତାଙ୍କ ନାମ :</span>
              <span className="font-semibold">{selectedCard.rln_name_v1}</span>
            </p>
            <p>
              <span className="font-semibold">Father's Name :</span>
              <span className="font-semibold"> {selectedCard.fatherName}</span>
            </p>

            <p>
              <span className="font-semibold">ଲିଙ୍ଗ / Gender :</span>
              <span className="font-semibold">
                {" "}
                {selectedCard.gender === "M" ? "ପୁରୁଷ" : "ସ୍ତ୍ରୀ"} /{" "}
                {selectedCard.gender === "M" ? "Male" : "Female"}
              </span>
            </p>

            <p>
              <span className="font-semibold">ଜନ୍ମ ତାରିଖ / ବୟସ :</span>
              <span className="font-semibold">
                {" "}
                {selectedCard.dob || selectedCard.age}
              </span>
            </p>

            <p>
              <span className="font-semibold">Date of Birth / Age :</span>
              <span className="font-semibold">
                {" "}
                {selectedCard.dob || selectedCard.age}
              </span>
            </p>
          </div>

          {/* Small black & white photo with vertical text */}
          <div className="absolute top-[50px] right-2 bg-white w-[38px] h-[60px] flex flex-col items-center p-[1px]">
            {/* Photo */}
            <img
              src={selectedCard.photoUrl}
              alt="BW Photo"
              className="w-full absolute bottom-0  right-3   h-[50px] mt-2  object-cover"
            />

            {/* EPIC number text vertically below image */}
            <div className="absolute bottom-0 right-0 w-full h-[20px]">
              <p
                className="absolute left-[90%] -top-0 -translate-x-1/2 -translate-y-1/2 
                 text-[0.30rem] font-bold text-black rotate-90 tracking-wider "
              >
                {selectedCard.epic_no}
              </p>
            </div>
          </div>
        </div>

        {/* === BACK SIDE (Skeleton Only) === */}
        <div
          className="w-[340px] h-[210px] flex flex-col bg-cover bg-center border border-black rounded py-2 relative pt-0 mt-0"
          style={{ backgroundImage: `url(${assets.voter})` }}
        >
          {/* Back Side Content */}
          <div className="flex gap-2 pl-[2px] w-[300px]">
            {/* QR Code + EPIC Number */}
            <div className="flex flex-col items-center justify-center w-[30%] mt-[4rem] gap-[2px]">
              <QRCodeCanvas
                value={
                  "name:" +
                  selectedCard.name +
                  ", Date of Birth:" +
                  selectedCard.dob +
                  ", Driving License No:" +
                  selectedCard.epic_no
                }
                level={"H"}
                size={60}
              />
              <h5 className="text-[0.55rem] mt-1 font-semibold">
                {selectedCard.epic_no}
              </h5>
            </div>

            {/* Voter Info */}
            <div className="w-[90%] flex flex-col justify-between break-words">
              <div className="mt-3">
                <div className="flex flex-wrap">
                  <span className="font-semibold text-[0.40rem]">ଠିକଣା : </span>
                  <span className="font-semibold text-[0.40rem] break-words">
                    {/* Address in Odia */}
                  </span>
                </div>

                <div className="flex flex-row flex-wrap gap-1 mt-2">
                  <span className="font-semibold text-[0.40rem]">
                    Address :{" "}
                  </span>
                  <span className="font-semibold text-[0.40rem] break-words">
                    {[
                      selectedCard.house_no !== "null"
                        ? selectedCard.house_no
                        : null,
                      selectedCard.area !== "null" ? selectedCard.area : null,
                      selectedCard.part_name !== "null"
                        ? selectedCard.part_name
                        : null,
                      selectedCard.assembly_constituency !== "null"
                        ? selectedCard.assembly_constituency
                        : null,
                      selectedCard.district !== "null"
                        ? selectedCard.district
                        : null,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </span>
                </div>
              </div>

              <div className="mt-2">
                <p className="font-semibold text-[0.40rem] break-words">
                  ନିରୀକ୍ଷଣାନ୍ତ ପଞ୍ଜିକରଣ ଅଧିକାରୀ,{" "}
                  {selectedCard.assembly_constituency_number}
                </p>

                <p className="font-semibold text-[0.40rem] break-words">
                  Electoral Registration Officer,{" "}
                  {selectedCard.assembly_constituency_number}-
                  {selectedCard.assembly_constituency_name}
                </p>

                <p className="font-semibold text-[0.40rem] break-words">
                  Issue Date: {selectedCard.issue_date}
                </p>

                <span className="font-semibold text-[0.40rem]">
                  ମନ୍ତବ୍ୟ ଦିଅନ୍ତୁ / Note
                </span>

                <p className="font-semibold text-[0.40rem] break-words">
                  ଆପଣଙ୍କର ନାମ ସାମ୍ପ୍ରତିକ ଭୋଟର ତାଲିକାରେ ଅଛି କି ନାହିଁ ଦୟାକରି
                  ପ୍ରତ୍ୟେକ ନିର୍ବାଚନରେ ଯାଞ୍ଚ କରନ୍ତୁ |
                </p>

                <p className="font-semibold text-[0.40rem] break-words">
                  Before every election, please check that your name exists in
                  the current electoral roll.
                </p>

                <p className="font-semibold text-[0.40rem] break-words">
                  ନିର୍ବାଚନର ଉଦ୍ଦେଶ୍ୟ ବ୍ୟତୀତ ଏହି କାର୍ଡ ଯୁଗର ପ୍ରମାଣ ନୁହେଁ |
                </p>

                <p className="font-semibold text-[0.40rem] break-words">
                  This card is not proof of age except for the purpose of
                  elections.
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t-1 border border-red-800  text-[0.55rem] mt-6   flex justify-between items-center" />

          <div className="flex justify-start gap-5  px-2">
            <p className="text-[0.50rem] mt-1 font-semibold">M00887200</p>
            <div className="flex items-center justify-center text-center gap-1">
              <img
                src={assets.phoneIcon}
                alt=""
                className="w-[0.50rem] h-[0.50rem] mt-2 items-center"
              />
              <p className="text-[0.50rem] font-semibold">1950</p>
            </div>
            <div className="flex items-center justify-center text-center gap-1">
              <FaGlobe size={8} className="mt-1" />
              <p className="text-[0.50rem] font-semibold">
                www.ceoodisha.nic.in
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default VoterIDCard;
